import * as Sentry from '@sentry/react';

const SENTRY_DSN = 'https://9d1588a8cf120c1e2e4c7e260b4796cb@sentry-new.amzn.pro/29';

export const initSentry = (): void => {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
};

export { Sentry };
